import React from 'react';
import {Box} from '@chakra-ui/react';

const FooterContainer = (props) => {
    return (
        <>
            <Box bg="bg-accent" color="on-accent" as="footer" role="contentinfo">
                <Box
                    px={['5', '10']}
                    height={'40px'}
                    borderBottom={'1px'}
                    borderColor={'whiteAlpha.200'}

                >
                    <Box borderX={'1px'} height={'100%'} borderColor={'whiteAlpha.200'}/>
                </Box>
                <Box px={['5', '10']}>
                    <Box borderX={'1px'} p={'20px'} height={'100%'} borderColor={'whiteAlpha.200'}
                         mx={'auto'}>
                        {props.children}
                    </Box>
                </Box>
                <Box
                    height={'40px'}
                    borderTop={'1px'}
                    borderColor={'whiteAlpha.200'}
                    px={['5', '10']}>
                    <Box borderX={'1px'} height={'100%'} borderColor={'whiteAlpha.200'}/>
                </Box>
            </Box>
        </>
    );
};

export default FooterContainer;
